<div class="vehicle-detail" *ngIf="showResult">
  <div class="result-message">
    <img src="assets/images/success.png" alt="Başarılı" />
    <h3>Tebrikler!</h3>
    <p>Vize başvurunuz başarıyla alınmıştır.</p>
  </div>

  <div class="selected-info">
    <h4>Seçilen Vize Bilgileri</h4>
    <div class="info-item" *ngIf="visaCountry">
      <span class="label">Vize Ülkesi:</span>
      <span class="value">{{ visaCountry }}</span>
    </div>
    <div class="info-item" *ngIf="visitReason">
      <span class="label">Vize Türü:</span>
      <span class="value">{{ visitReason }}</span>
    </div>
    <div class="info-item" *ngIf="visaType">
      <span class="label">Vize Süresi:</span>
      <span class="value">{{ visaType }}</span>
    </div>
    <div class="info-item" *ngIf="applicationType">
      <span class="label">Başvuru Türü:</span>
      <span class="value">{{ applicationType }}</span>
    </div>
    <div class="info-item" *ngIf="visaLevel">
      <span class="label">Vize Aciliyet Seviyesi:</span>
      <span class="value">{{ visaLevel }}</span>
    </div>
  </div>
</div>

<div class="car">
  <div class="car-img shape" style="background-image: url(../../../../assets/images/shape.png);">
    <div class="shape" ></div>
    <div class="icon-box"> <i class="fa fa-pie-chart"></i> </div>
    <h6>Seçtiğiniz bilgiler listelenmektedir</h6>
  </div>

  <div *ngIf="visaCountry" class="prop">
    <span class="cleft">Vize Ülkesi</span>
    <span class="cright">{{ visaCountry }}</span>
  </div>
  <div *ngIf="visitReason" class="prop">
    <span class="cleft">Vize Türü</span>
    <span class="cright">{{ visitReason }}</span>
  </div>
  <div *ngIf="visaType" class="prop">
    <span class="cleft">Vize Süresi</span>
    <span class="cright">{{ visaType }}</span>
  </div>

  <div *ngIf="applicationType != ''" class="prop">
    <span class="cleft">Başvuru Türü</span>
    <span class="cright">{{ applicationType }}</span>
  </div>

  <div class="visa-price">
    <h3>TOPLAM:</h3><span class="tl">{{total |currency :"$ "}}</span>
  </div>
</div>

<div class="sidebar-cta-box wow fadeInUp" data-wow-delay="0.25s" style="visibility: visible; animation-delay: 0.25s; animation-name: fadeInUp;">
  <!-- Sidebar CTA Content Start -->
  <div class="sidebar-cta-content">
      <h3><i class="fa-solid fa-circle-info"></i>Dikkat Edilmesi Gereken Husus</h3>
      <p>
        Pasaport bitiş tarihiniz ile vize başvuru tarihiniz arasında en az 6 ay süre bulunmak zorundadır.
        Aksi takdirde başvuru işlemi gerçekleşmemektedir.</p>
  </div>
  <!-- Sidebar CTA Content End -->

  <!-- Sidebar CTA Contact Start -->
  <div class="sidebar-cta-contact">
      <!-- Sidebar CTA Contact Item Start -->
      <div class="sidebar-cta-contact-item">
          <div class="icon-box">
            <i class="fa-solid fa-phone-volume"></i>
          </div>
          <div class="cta-contact-item-content">
              <p><a class="visadetailPhoneMail" style="color: white;" href="tel:{{contact?.phone}}">{{contact?.phone}}</a></p>
          </div>
      </div>
      <!-- Sidebar CTA Contact Item Start -->

      <!-- Sidebar CTA Contact Item Start -->
      <div class="sidebar-cta-contact-item">
        <div class="icon-box">
          <i class="fa-solid fa-envelope"></i>
        </div>
          <div class="cta-contact-item-content">
              <p><a class="visadetailPhoneMail" style="color: white;" href="mailto:{{contact?.email}}" target="_blank">{{contact?.email}}</a></p>
          </div>
      </div>
      <!-- Sidebar CTA Contact Item Start -->
  </div>
  <!-- Sidebar CTA Contact End -->
</div>